import { Vehicle } from "../../../../types";
import Button from "../../../../components/Button/Button";
import carIcon from "../../../../assets/images/car_icon.svg";
import "./styles.css";
import { Link } from "@inertiajs/react";
import { Checkbox } from "../../../../components/ui";
import useVehicleCompare from "../../../../utils/VehicleCompareProvider";
import { useState } from "react";
import ImageFallback from "../../../../components/ImageFallback/ImageFallback";
import { trackEvent } from "../../../../utils/analytics";

type VehicleCardProps = {
  vehicle: Vehicle;
  showCompare?: boolean;
};

const VehicleCard = (props: VehicleCardProps) => {
  const { vehicle, showCompare = true } = props;
  const { toggleId, ids } = useVehicleCompare();

  const maxSraCommercialLength = 40;

  const detailUrl = `/vehicles/${vehicle.slug}`;
  const titleTrunc = (name: string) =>
    name.length > maxSraCommercialLength
      ? name.slice(0, maxSraCommercialLength) + "..."
      : name;

  const isCompared = ids.includes(vehicle.id);
  const [imageError, setImageError] = useState(false);

  const handleCompareButtonClick = () => {
    trackEvent({
      name: "Comparer un véhicule",
      params: {
        category: "Interaction",
        action: "Click",
        label: "Comparer un véhicule",
        page_type: "Véhicule card",
      },
    });
    toggleId(vehicle.id);
  };

  return (
    <div
      className="vehicle-card"
      style={{ boxShadow: "0 0 4px 0 rgba(0, 0, 0, 0.10)" }}
    >
      {showCompare && (
        <div className="vehicle-card-compare">
          <Button
            styleClass="compare-button"
            onClick={handleCompareButtonClick}
          >
            <Checkbox className="mr-2" checked={isCompared} />
            {isCompared ? "Effacer" : "Comparer"}
          </Button>
        </div>
      )}
      <div className="vehicle-card-content">
        {imageError || !vehicle.photo_url ? (
          <ImageFallback />
        ) : (
          <img
            src={vehicle.photo_url}
            alt={vehicle.name}
            className="vehicle-card-content-image"
            onError={() => setImageError(true)}
          />
        )}
        <div>
          <Link href={detailUrl} className="brand-name">
            {vehicle.brand.title} - {titleTrunc(vehicle.name)}
          </Link>
        </div>
        <div className="vehicle-card-content-note">
          <div className="note-container">
            <span className="note_value primary-color">
              {vehicle.note.toLocaleString()}
            </span>
            <span className="text-sm leading-4">/ 10</span>
          </div>
          <span className="avis leading-4">{vehicle.reviews_count} avis</span>
        </div>
        <Button styleClass="detail_button" asChild>
          <Link href={detailUrl}>
            <img
              src={carIcon}
              alt="logo"
              className="w-5 block lg:hidden xl:block"
            />
            Voir la fiche complète
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default VehicleCard;
